import React from "react";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

import { useDeleteDocumentType } from "../hooks/useDeleteDocumentType";

export const DeleteDocumentTypeModal = ({
  isOpen,
  onClose,
  documentType,
  onSuccess,
}) => {
  const deleteMutation = useDeleteDocumentType();

  const handleDelete = () => {
    deleteMutation.mutate(documentType, {
      onSuccess: () => {
        onSuccess?.();
        onClose();
      },
    });
  };

  if (!documentType) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title="Delete Document Type"
      width={480}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <p style={{ fontSize: "16px", color: "#26252c", margin: 0 }}>
          Are you sure you want to delete <strong>{documentType.name}</strong>?
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
          <Button variant="outline" size="large" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="large"
            onClick={handleDelete}
            disabled={deleteMutation.isPending}
          >
            {deleteMutation.isPending ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
